<!-- 方案协助（客户协同）的添加 / 编辑表单弹窗 -->
<template>
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="60%">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="110px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="客户名称" prop="customerId">
            <el-select
              v-model="formData.customerId"
              class="w-1/1"
              filterable
              placeholder="请选择客户"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="formData.projectName" placeholder="请输入项目名称" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="销售" prop="salesUserId">
            <el-select
              v-model="formData.salesUserId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择销售"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="参与人员" prop="participantUserIds">
            <el-select
              v-model="formData.participantUserIds"
              class="w-1/1"
              clearable
              collapse-tags
              collapse-tags-tooltip
              filterable
              multiple
              placeholder="请选择参与人员"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="负责人" prop="ownerUserId">
            <el-select
              v-model="formData.ownerUserId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择负责人"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="知晓人" prop="knowerUserIds">
            <el-select
              v-model="formData.knowerUserIds"
              class="w-1/1"
              clearable
              collapse-tags
              collapse-tags-tooltip
              filterable
              multiple
              placeholder="请选择知晓人"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="方案负责人" prop="planUserId">
            <el-select
              v-model="formData.planUserId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择方案负责人"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报价负责人" prop="quoteUserId">
            <el-select
              v-model="formData.quoteUserId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择报价负责人"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="完成状态" prop="status">
            <el-select v-model="formData.status" class="w-1/1" placeholder="请选择完成状态">
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_PLAN_ASSIST_STATUS)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="协同说明" prop="assistDesc">
            <el-input
              v-model="formData.assistDesc"
              :rows="3"
              placeholder="请输入协同说明"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="方案说明" prop="planDesc">
            <el-input
              v-model="formData.planDesc"
              :rows="3"
              placeholder="请输入方案说明"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="需要准备" prop="prepare">
            <el-input
              v-model="formData.prepare"
              :rows="3"
              placeholder="请输入需要准备的内容"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="formData.remark"
              :rows="2"
              placeholder="请输入备注"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="跟进回复" prop="followReply">
            <el-input
              v-model="formData.followReply"
              :rows="3"
              placeholder="请输入跟进回复"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="相关文件" prop="fileUrls">
            <!-- 方案协助附件是业务凭据，一律直接上传，不走素材库 -->
            <UploadFile
              v-model="formData.fileUrls"
              class="min-w-80px"
              :use-material-library="false"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="抄送员" prop="ccUserIds">
            <el-select
              v-model="formData.ccUserIds"
              class="w-1/1"
              clearable
              collapse-tags
              collapse-tags-tooltip
              filterable
              multiple
              placeholder="请选择要抄送的人员"
            >
              <el-option
                v-for="item in userOptions"
                :key="item.id"
                :label="item.nickname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">保 存</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { PlanAssistApi } from '@/api/crm/planAssist'
import * as CustomerApi from '@/api/crm/customer'
import * as UserApi from '@/api/system/user'

defineOptions({ name: 'PlanAssistForm' })

const { t } = useI18n() // 国际化
const message = useMessage() // 消息弹窗

const dialogVisible = ref(false) // 弹窗的是否展示
const dialogTitle = ref('') // 弹窗的标题
const formLoading = ref(false) // 表单的加载中
const formType = ref('') // 表单的类型：create - 新增；update - 修改
const customerList = ref<any[]>([]) // 客户下拉
const userOptions = ref<UserApi.UserVO[]>([]) // 用户下拉

/** 空表单数据 */
const emptyFormData = () => ({
  id: undefined,
  customerId: undefined,
  projectName: undefined,
  salesUserId: undefined,
  ownerUserId: undefined,
  planUserId: undefined,
  quoteUserId: undefined,
  participantUserIds: [],
  knowerUserIds: [],
  ccUserIds: [],
  status: undefined,
  assistDesc: undefined,
  planDesc: undefined,
  prepare: undefined,
  remark: undefined,
  followReply: undefined,
  fileUrls: []
})

const formData = ref<any>(emptyFormData())
const formRules = reactive({
  customerId: [{ required: true, message: '客户名称不能为空', trigger: 'change' }],
  salesUserId: [{ required: true, message: '销售不能为空', trigger: 'change' }],
  planUserId: [{ required: true, message: '方案负责人不能为空', trigger: 'change' }],
  quoteUserId: [{ required: true, message: '报价负责人不能为空', trigger: 'change' }],
  status: [{ required: true, message: '完成状态不能为空', trigger: 'change' }]
})
const formRef = ref() // 表单 Ref

/** 打开弹窗 */
const open = async (type: string, id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = type === 'create' ? '新增协作管理' : '编辑协作管理'
  formType.value = type
  resetForm()
  // 加载下拉数据
  customerList.value = await CustomerApi.getCustomerSimpleList()
  userOptions.value = await UserApi.getSimpleUserList()
  // 修改时，加载数据
  if (id) {
    formLoading.value = true
    try {
      const data = await PlanAssistApi.getPlanAssist(id)
      formData.value = {
        id: data.id,
        customerId: data.customerId,
        projectName: data.projectName,
        salesUserId: data.salesUserId,
        ownerUserId: data.ownerUserId,
        planUserId: data.planUserId,
        quoteUserId: data.quoteUserId,
        participantUserIds: data.participantUserIds || [],
        knowerUserIds: data.knowerUserIds || [],
        ccUserIds: data.ccUserIds || [],
        status: data.status,
        assistDesc: data.assistDesc,
        planDesc: data.planDesc,
        prepare: data.prepare,
        remark: data.remark,
        followReply: data.followReply,
        fileUrls: data.fileUrls || []
      }
    } finally {
      formLoading.value = false
    }
  } else {
    // 新增时，完成状态默认「进行中」
    formData.value.status = 1
  }
}
defineExpose({ open }) // 提供 open 方法，用于打开弹窗

/** 提交表单 */
const emit = defineEmits(['success']) // 定义 success 事件，用于操作成功后的回调
const submitForm = async () => {
  // 校验表单
  await formRef.value.validate()
  // 提交请求
  formLoading.value = true
  try {
    const data = { ...formData.value }
    if (formType.value === 'create') {
      await PlanAssistApi.createPlanAssist(data)
      message.success(t('common.createSuccess'))
    } else {
      await PlanAssistApi.updatePlanAssist(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    // 发送操作成功的事件
    emit('success')
  } finally {
    formLoading.value = false
  }
}

/** 重置表单 */
const resetForm = () => {
  formData.value = emptyFormData()
  formRef.value?.resetFields()
}
</script>
